module.exports = __webpack_public_path__ + "static/media/utensil-spoon.55458952.svg";